import { FAQ } from "../../models/FAQ.tsx";
import { fetchFAQQuestions } from "../../helpers/faqQuery.ts";

export async function showFAQ(): Promise<FAQ[]> {
    return fetchFAQQuestions();
}
